import React, { useState } from "react";
import { Col } from "reactstrap";
import DashPanel from "../common/DashPanel";
import ItemSaleRow from "../common/ItemSaleRow";
import { T } from "../../constants/theme";
import { itemSaleData } from "../../data/dashboardMockData";

/** Combined Most Sold / Least Sold panel with header select toggle. */
const ItemSaleSection = ({ loading }) => {
  const [view, setView] = useState("most");
  const rows = view === "most" ? itemSaleData.mostSold : itemSaleData.leastSold;

  return (
    <Col xl={6}>
      <DashPanel
        title="Item Sales"
        icon={view === "most" ? "bx bx-trending-up" : "bx bx-trending-down"}
        iconColor={view === "most" ? T.green : T.red}
        loading={loading}
        headerRight={
          <select
            className="sad-panel-select"
            value={view}
            onChange={(e) => setView(e.target.value)}
            aria-label="Choose item list"
          >
            <option value="most">Most Sold</option>
            <option value="least">Least Sold</option>
          </select>
        }
      >
        <div className="sad-scroll-list">
          {rows.map((item, i) => (
            <ItemSaleRow key={i} item={item} type={view} loading={loading} />
          ))}
        </div>
      </DashPanel>
    </Col>
  );
};

export default ItemSaleSection;
